function Custom404() {
  return <h1 className="my-auto text-center">404 - Radio Frequency Not Found ):</h1>;
}

export default Custom404;
